import {createStorage} from 'persistme'

const ChatRoomPinStorage = createStorage('__CHAT__ROOM__PIN__')

const getPinStorageKey = roomId => `${roomId}.pin`
const getNameStorageKey = roomId => `${roomId}.name`

export const setPin = (roomId, pin) =>
  ChatRoomPinStorage.set(getPinStorageKey(roomId), pin)

export const getPin = roomId => ChatRoomPinStorage.get(getPinStorageKey(roomId))

export const setName = (roomId, pin) =>
  ChatRoomPinStorage.set(getNameStorageKey(roomId), pin)

export const getName = roomId =>
  ChatRoomPinStorage.get(getNameStorageKey(roomId))
